import React, { ReactNode } from 'react';

interface IProperties {
  children: ReactNode;
  error?: boolean;
}

const PreviewLayout = ({ children, error }: IProperties) => {
  return error ||
    !children ||
    (Array.isArray(children) && children.length === 0) ? (
    <div className="w-full text-center">
      {error ? 'Could not display data due to an error.' : 'No data no show'}
    </div>
  ) : (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6 gap-6 mb-8">
      {children}
    </div>
  );
};

export default PreviewLayout;
